var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { id: "confirm-modal", width: 400 },
      model: {
        value: _vm.auxValue,
        callback: function ($$v) {
          _vm.auxValue = $$v
        },
        expression: "auxValue",
      },
    },
    [
      _c("div", { staticClass: "modal-card-body has-text-centered" }, [
        _c("h3", { staticClass: "modal-title" }, [_vm._v("¿Seguro?")]),
        _c("div", { staticClass: "modal-content" }, [
          _c("p", [
            _vm._v(" Hay "),
            _c("span", { staticClass: "has-text-weight-bold" }, [
              _vm._v(_vm._s(_vm.numberOfAccountableEntities)),
            ]),
            _vm._v(
              " registro" +
                _vm._s(_vm.numberOfAccountableEntities > 1 ? "s" : "") +
                " que se marcará" +
                _vm._s(_vm.numberOfAccountableEntities > 1 ? "n" : "") +
                " como contabilizado" +
                _vm._s(_vm.numberOfAccountableEntities > 1 ? "s" : "") +
                ". "
            ),
          ]),
        ]),
        _c("div", { staticClass: "modal-footer columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-button-secondary is-rounded",
                  on: {
                    click: function ($event) {
                      _vm.auxValue = false
                    },
                  },
                },
                [_vm._v(" Cancelar ")]
              ),
            ]),
          ]),
          _c("div", { staticClass: "column" }, [
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: {
                    id: "confirm-to-account-button",
                    disabled: _vm.accountingButtonDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("account")
                    },
                  },
                },
                [_vm._v(" Confirmar ")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }